import { AssignmentDeleteValidation } from 'types/assignments';
import { t } from 'utils/getTranslations';

// Priority order mirrors MatterAssignmentBizService.checkIfAssignmentCanBeDeleted
// so the frontend warning matches the exception that would have been thrown if the
// backend validation ran first. Returns null when there are no blockers.
export const buildAssignmentDeleteBlockerMessage = (validation: AssignmentDeleteValidation): string | null => {
    if (validation.hasSentInvoice) {
        return t('assignments.alerts.delete-blocked-sent-invoice');
    }
    if (validation.hasTimecards) {
        const base = t('assignments.alerts.delete-blocked-timecards');
        return validation.draftTimecardAuthors.length > 0
            ? base +
                  ' ' +
                  t('assignments.alerts.delete-blocked-timecards-authors-suffix', {
                      authors: validation.draftTimecardAuthors.join(', '),
                  })
            : base;
    }
    return null;
};
